import React, { useState, useEffect } from 'react';
import { Bar, Pie, Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js';
import { Button, Modal, Table, Col, Row, Menu, Dropdown } from 'antd';
import { DatePicker, Select } from 'antd';
import { Collapse } from 'antd';
import moment from 'moment';
import { changeIndex } from '../../../toolkit/slices/cart/cartSlice';
import { useDispatch } from 'react-redux';
import { FaPencilAlt, FaFilter } from "react-icons/fa";
import { IoIosRefresh } from "react-icons/io";
import formatIndianNumber from '../../../../utils/formatIndianNumber';

const { Panel } = Collapse;
// Register necessary components with Chart.js
ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

const { Option } = Select;
const { RangePicker } = DatePicker;

const BarChartComponent = () => {
    const [chartDataSales, setChartDataSales] = useState({ labels: [], datasets: [] });
    const [chartDataSalesPerson, setChartDataSalesPerson] = useState({ labels: [], datasets: [] });
    const [allData, setAllData] = useState([]);
    const dispatch = useDispatch();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isModalVisibletwo, setIsModalVisibletwo] = useState(false);
    const [totalData, setTotalData] = useState({});
    const [childModalData, setChildModalData] = useState({});
    const [chartData, setChartData] = useState({ Area: [], datasets: [] });
    const [areaChart, setAreaChart] = useState({})
    const [isMoreModalVisible, setIsMoreModalVisible] = useState(false);
    const [industryChartData, setIndustryChartData] = useState({ labels: [], datasets: [] })
    const [IndustryChart, setIndustryChart] = useState({})
    const [isModalVisiblePie, setIsModalVisiblePie] = useState(false);
    const [modalData, setModalData] = useState([]);
    const [dates, setDates] = useState([moment().startOf('month').subtract(1, 'month'), moment().endOf('month')]);
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    // Fetch sales data

    // // Function to format numbers with suffixes
    // function formatNumber(num) {
    //     if (num >= 10000000) {
    //         return (num / 10000000).toFixed(2) + ' Cr';
    //     } else if (num >= 100000) {
    //         return (num / 100000).toFixed(2) + ' Lakh';
    //     } else if (num >= 1000) {
    //         return (num / 1000).toFixed(2) + ' K';
    //     } else {
    //         return num.toString();
    //     }
    // }

    const handleTabChange = (num) => {
        console.log("🤦‍♀️🤦‍♀️🤦‍♀️🤦‍♂️",num)
        dispatch(changeIndex(num))
    }
    const fetchSalesData = async () => {
        if (!dates || dates.length < 2 || !dates[0] || !dates[1]) {
            console.warn("Invalid date range provided");
            return;
        }

        const startDate = dates[0].format('YYYY-MM-DD');
        const endDate = dates[1].format('YYYY-MM-DD');

        try {
            const response = await fetch(`${apiBaseUrl}/analysisApi/sales/get_clients?start_date=${startDate}&end_date=${endDate}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify({
                    start_date: startDate,
                    end_date: endDate,
                }),
            });

            if (!response.ok) throw new Error('Network response was not ok');

            const data = await response.json();
            const topData = data.top || [];
            const totalData = data.total || {};

            // Extract names and sales values
            const labels = topData.map(item => item.name);
            const salesData = topData.map(item => item.sales);

            setChartDataSales({
                labels: labels,
                datasets: [
                    {
                        label: 'Sales',
                        data: salesData,
                        backgroundColor: 'rgba(0, 143, 251, 1)',
                        borderColor: 'rgba(0, 143, 251, 1)',
                        borderWidth: 1,
                    },
                ],
            });

            setTotalData(totalData);
            console.log("totalData", totalData)
        } catch (error) {
            console.error('Error fetching salesetChartDataSaless data:', error);
        }
    };


    // Fetch sales person data
    const fetchSalesPersonData = async () => {
        if (!dates || dates.length < 2 || !dates[0] || !dates[1]) {
            console.warn("Invalid date range provided");
            return;
        }

        const startDate = dates[0].format('YYYY-MM-DD');
        const endDate = dates[1].format('YYYY-MM-DD');

        try {
            const response = await fetch(`${apiBaseUrl}/analysisApi/sales/get_sales_person?start_date=${startDate}&end_date=${endDate}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify({
                    start_date: startDate,
                    end_date: endDate,
                }),
            });

            if (!response.ok) throw new Error('Network response was not ok');

            const data = await response.json();
            const sortedData = data.sort((a, b) => b.packageRate - a.packageRate);
            const topData = sortedData.slice(0, 5);

            // Extract names and packageRate values
            const labels = topData.map(item => item.salesPerson);
            const packageRateData = topData.map(item => item.packageRate);

            setChartDataSalesPerson({
                labels: labels,
                datasets: [
                    {
                        label: 'Sales',
                        data: packageRateData,
                        backgroundColor: 'rgba(0, 143, 251, 1)',
                        borderColor: 'rgba(0, 143, 251, 1)',
                        borderWidth: 1,
                    },
                ],
            });

            setAllData(data);
        } catch (error) {
            console.error('Error fetching sales person data:', error);
        }
    };




    const fetchAreaWiseData = async () => {
        if (!dates || dates.length < 2 || !dates[0] || !dates[1]) {
            console.warn("Invalid date range provided");
            return;
        }

        const startDate = dates[0].format('YYYY-MM-DD');
        const endDate = dates[1].format('YYYY-MM-DD');
        const response = await fetch(`${apiBaseUrl}/analysisApi/sales/get_area?start_date=${startDate}&end_date=${endDate}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({
                start_date: startDate,
                end_date: endDate,
            }),
        });

        if (!response.ok) {
            console.error('Failed to fetch data');
            return;
        }

        const data = await response.json();
        console.log("AreaWiseData", data); // Log the data to the console to verify

        // Limit to top 5
        const top5Data = data.slice(0, 5);

        // Prepare chart data
        const labels = top5Data.map(item => item.Area);
        const packageRate = top5Data.map(item => item.packageRate);

        setChartData({
            labels: labels,
            datasets: [
                {
                    label: 'Sales',
                    data: packageRate,
                    backgroundColor: 'rgba(0, 143, 251, 1)',
                    borderColor: 'rgba(0, 143, 251, 1)',
                    borderWidth: 1,
                },
            ],
        });

        setAreaChart(data);
    };
    const fetchIndustryWiseData = async () => {
        if (!dates || dates.length < 2 || !dates[0] || !dates[1]) {
            console.warn("Invalid date range provided");
            return;
        }

        const startDate = dates[0].format('YYYY-MM-DD');
        const endDate = dates[1].format('YYYY-MM-DD');
        const response = await fetch(`${apiBaseUrl}/analysisApi/sales/get_industry?start_date=${startDate}&end_date=${endDate}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({
                start_date: startDate,
                end_date: endDate,
            }),
        });

        if (!response.ok) {
            console.error('Failed to fetch data');
            return;
        }

        const data = await response.json();
        console.log("IndustryWiseData", data); // Log the data to the console to verify

        // Extract the pie data from the response
        const pieData = data.pie_data;
        const TotalIndustryData = data.total_data;

        // Check if pieData is an array
        if (!Array.isArray(pieData)) {
            console.error('Expected an array but got:', pieData);
            return;
        }

        // Limit to top 5
        const topData = pieData;

        // Prepare chart data
        const labels = topData.map(item => item.name);
        const values = topData.map(item => item.percentage);
        const BrandSegment = TotalIndustryData.map(item => item.brandSegment);
        const sales = TotalIndustryData.map(item => item.sales)

        setIndustryChartData({
            labels: labels,
            datasets: [
                {
                    data: values,
                    backgroundColor: [
                        'rgba(255, 99, 132, 0.2)',
                        'rgba(54, 162, 235, 0.2)',
                        'rgba(255, 206, 86, 0.2)',
                        'rgba(75, 192, 192, 0.2)',
                        'rgba(153, 102, 255, 0.2)',
                        'rgba(211, 211, 211, 0.2)', // Light grey background color
                    ],
                    borderColor: [
                        'rgba(255, 99, 132, 1)',
                        'rgba(54, 162, 235, 1)',
                        'rgba(255, 206, 86, 1)',
                        'rgba(75, 192, 192, 1)',
                        'rgba(153, 102, 255, 1)',
                        'rgba(211, 211, 211, 1)', // Light grey border color
                    ],
                    borderWidth: 1,
                }
                ,
            ],
        });

        setIndustryChart(topData);
        setModalData(TotalIndustryData); // Set the modal data here
        // setIsModalVisiblePie(true);
        console.log("industryChartData", industryChartData);
    };

    const PieChartColums = [
        {
            title: 'Brand Segment',
            dataIndex: 'brandSegment',
            key: 'brandSegment',
        },
        {
            title: 'Total Sales',
            dataIndex: 'sales',
            key: 'sales',
            render: (text) => formatINR(text),
        },
    ];

    const showModalPie = (data) => {
        setModalData(data);
        setIsModalVisible(true);
    };

    useEffect(() => {
        fetchSalesData();
        fetchSalesPersonData();
        fetchAreaWiseData();
        fetchIndustryWiseData();
    }, [dates]);

    const handleDateChange = (value) => {
        setDates(value);
    };

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        setIsModalVisibletwo(false); // Close both modals
        setIsMoreModalVisible(false);
        setIsModalVisiblePie(false);
    };
   
    const columns = [
        {
            title: 'Employee name',
            dataIndex: 'salesPerson',
            key: 'salesPerson',
        },
        {
            title: 'Total Sales',
            dataIndex: 'packageRate',
            key: 'packageRate',
            render: (text) => formatINR(text),
        },
    ];

    const AreWisecolumns = [
        {
            title: 'All Areas',
            dataIndex: 'Area',
            key: 'Area',
        },
        {
            title: 'Total Sales',
            dataIndex: 'packageRate',
            key: 'packageRate',
            render: (text) => formatINR(text),
        },
    ];

    const columnstwo = [
        {
            title: 'Party Name',
            dataIndex: 'partyName',
            key: 'partyName',
        },
        {
            title: 'Total Sales',
            dataIndex: 'totalSales',
            key: 'totalSales',
            render: (text) => formatINR(text),
        },
    ];

    const showModaltwo = () => {
        setIsModalVisibletwo(true);
    };

    const dataSource = Object.keys(totalData).map(key => ({
        key,
        partyName: totalData[key].partyName || key,
        totalSales: totalData[key].totalSales,
        brandContributions: totalData[key].brandContributions,
    }));
    const handleRowClick = (record) => {
        setChildModalData(record);
        // setIsChildModalVisible(true);
    };

    // const handleChildModalCancel = () => {
    //     setIsChildModalVisible(false);

    // };


    const showMoreModal = () => {
        setIsMoreModalVisible(true);
    };

    const formatINR = (number) => {
        if (!number) return '0';
        let x = number.toString();
        let lastThree = x.substring(x.length - 3);
        let otherNumbers = x.substring(0, x.length - 3);
        if (otherNumbers !== '') {
            lastThree = ',' + lastThree;
        }
        let formattedNumber = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
        return formattedNumber;
    };



    const setLastMonthDates = () => {
        const startOfLastMonth = moment().subtract(1, 'month').startOf('month');
        const endOfLastMonth = moment().subtract(1, 'month').endOf('month');
        console.log(`Start of last month: ${startOfLastMonth.format('YYYY-MM-DD')}`);
        console.log(`End of last month: ${endOfLastMonth.format('YYYY-MM-DD')}`);
        setDates([startOfLastMonth, endOfLastMonth]);
        // fetchSalesData(startOfLastMonth, endOfLastMonth);
    };
    const setLastWeekDates = () => {
        const startOfLastWeek = moment().subtract(1, 'week').startOf('week');
        const endOfLastWeek = moment().subtract(1, 'week').endOf('week');
        console.log(`Start of last week: ${startOfLastWeek.format('YYYY-MM-DD')}`);
        console.log(`End of last week: ${endOfLastWeek.format('YYYY-MM-DD')}`);
        setDates([startOfLastWeek, endOfLastWeek]);
        // fetchSalesData(startOfLastWeek, endOfLastWeek);
    };

    const setLastYearDates = () => {
        const startOfLastYear = moment().subtract(1, 'year').startOf('year');
        const endOfLastYear = moment().subtract(1, 'year').endOf('year');
        console.log(`Start of last year: ${startOfLastYear.format('YYYY-MM-DD')}`);
        console.log(`End of last year: ${endOfLastYear.format('YYYY-MM-DD')}`);
        setDates([startOfLastYear, endOfLastYear]);
        // fetchSalesData(startOfLastYear, endOfLastYear);
    };
    const handleSelectChange = (value) => {
        switch (value) {
            case "LastYear":
                setLastYearDates();
                break;
            case "LastMonth":
                setLastMonthDates();
                break;
            case "LastWeek":
                setLastWeekDates();
                break;
            default:
                break;
        }
    };
    // const menu = (
    //     <Menu style={{ padding: "10px 10px" }}>

    //         <Menu.Item>
    //             <div onClick={(e) => e.stopPropagation()}>
    //                 <Select onChange={handleSelectChange} placeholder="Select Option" style={{ width: '100%' }}>
    //                     <Option value="LastYear">Last Year</Option>
    //                     <Option value="LastMonth">Last Month</Option>
    //                     <Option value="LastWeek">Last Week</Option>
    //                 </Select>
    //             </div>
    //         </Menu.Item>
    //     </Menu>
    // );
    const handleRefresh = () =>{
        setLastYearDates();
    };
    return (
        <div>
            <div className="SalesContainer">
                <div className="LocationAnalysisContainerHeader">
                    {/* <h4 style={{ fontSize: "20px", fontWeight: "600", margin: "0px" }}>Sales Analysis</h4> */}
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "end", }}>
                        {/* <Dropdown overlay={menu} placement="bottomRight" arrow trigger={['click']} >
                            <Button><FaFilter /></Button>
                        </Dropdown> */}
                        <Button onClick={handleRefresh} style={{margin:"0px 5px"}}><IoIosRefresh/></Button>
                        <Select onChange={handleSelectChange} placeholder="Select" style={{ width: '120px' }}>
                            <Option value="LastYear">Last Year</Option>
                            <Option value="LastMonth">Last Month</Option>
                            <Option value="LastWeek">Last Week</Option>
                        </Select>
                        <RangePicker
                            style={{ width: '200px', marginLeft: "5px" }}
                            onChange={handleDateChange}
                            format="YYYY-MM-DD"
                        />
                    </div>
                </div>
            </div>
            <div >
                <Row gutter={16}>
                    <Col span={12}>
                        <div className='CardEdit'>
                            <div style={{ display: "flex", width: "100%", justifyContent: "space-between", alignItems: "center" }}>
                                <h6>Top Clients </h6>
                                <Button onClick={() => handleTabChange(2)} style={{width:"100px"}}>View Details</Button>
                            </div>
                            {/* <br /> */}
                            <Bar
                                data={chartDataSales}
                                options={{
                                    indexAxis: 'x',
                                    responsive: true,
                                    plugins: {
                                        legend: {
                                            display: false
                                        },
                                        tooltip: {
                                            callbacks: {
                                                label: function (context) {
                                                    // Convert the raw value to a string formatted as Indian Rupees with commas
                                                    const formattedValue = context.raw.toLocaleString('en-IN', {
                                                        minimumFractionDigits: 0,
                                                    });
                                                    return `Sales: ₹${formattedValue}`;
                                                },
                                            },
                                        },
                                    },
                                    scales: {
                                        x: {
                                            title: {
                                                display: true,
                                                text: 'Client Names',
                                            },
                                            ticks: {
                                                font: {
                                                    size: 9, // Control the font size for x-axis labels
                                                },
                                            },
                                        },
                                        y: {
                                            title: {
                                                display: true,
                                                text: 'Sales',
                                            },
                                            ticks: {
                                                callback: function (value) {
                                                    if (value >= 10000000) {
                                                        return (value / 10000000).toFixed(0) + 'C'; // Crores
                                                    } else if (value >= 100000) {
                                                        return (value / 100000).toFixed(0) + 'L'; // Lakhs
                                                    } else if (value >= 1000) {
                                                        return (value / 1000).toFixed(0) + 'K'; // Thousands
                                                    } else {
                                                        return value; // Less than 1000
                                                    }
                                                },

                                            },
                                        },
                                    },
                                }}
                            />
                            {/* <br /> */}
                            {/* <Button type="primary" onClick={showModaltwo}>
                                View All Contribution
                            </Button> */}
                            <Modal
                                title="Total Sales Data"
                                visible={isModalVisibletwo}
                                onCancel={handleCancel}
                                footer={null}
                            >
                                <br />
                                <div id='CollpaseEdit'>
                                    <Collapse accordion>
                                        {dataSource
                                            .sort((a, b) => b.totalSales - a.totalSales) // Sort dataSource based on totalSales in descending order
                                            .map((record) => (
                                                <Panel
                                                    key={record.key}
                                                    header={
                                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                            <span style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                                                                {columnstwo.map((column) => (
                                                                    <span key={column.key} style={{ marginLeft: '10px' }}>
                                                                        <strong>{column.title}: </strong>
                                                                        {column.dataIndex === 'totalSales'
                                                                            ? formatINR(record[column.dataIndex])
                                                                            : record[column.dataIndex]}
                                                                    </span>
                                                                ))}
                                                            </span>
                                                        </div>
                                                    }
                                                    onClick={() => handleRowClick(record)}
                                                >
                                                    <p>Party Name: {childModalData.partyName}</p>
                                                    <p>Total Sales: {formatINR(childModalData.totalSales)}</p>
                                                    <p>Brand Contributions:</p>
                                                    <ul>
                                                        {childModalData.brandContributions ? (
                                                            Object.entries(childModalData.brandContributions).map(([brand, contribution]) => (
                                                                <li key={brand}>
                                                                    {brand}: {formatIndianNumber(contribution)}
                                                                </li>
                                                            ))
                                                        ) : (
                                                            <li>N/A</li>
                                                        )}
                                                    </ul>
                                                </Panel>
                                            ))}
                                    </Collapse>

                                </div>
                                {/* <Table
                                    dataSource={dataSource}
                                    columns={columnstwo}
                                    onRow={(record) => ({
                                        onClick: () => handleRowClick(record),
                                    })}
                                /> */}

                            </Modal>
                            {/* <Modal
                                title="Brand Contributions"
                                visible={isChildModalVisible}
                                onCancel={handleChildModalCancel}
                                footer={null}
                            >
                              
                            </Modal> */}
                        </div>
                    </Col>
                    <Col span={12}>
                        <div className='CardEdit' >
                            <div style={{ display: "flex", width: "100%", justifyContent: "space-between", alignItems: "center" }}>
                                <h6>Top Employee's</h6>
                                <Button onClick={() => handleTabChange(3)} style={{width:"100px"}}>View Details</Button>
                            </div>
                            {/* <br /> */}
                            <Bar
                                data={chartDataSalesPerson}
                                options={{
                                    indexAxis: 'x',
                                    responsive: true,
                                    plugins: {
                                        legend: {
                                            display: false
                                        },
                                        tooltip: {
                                            callbacks: {
                                                label: function (context) {
                                                    // Use the formatIndianNumber function to format the raw value
                                                    const formattedValue = formatIndianNumber(context.raw);
                                                    return `Sales: ₹${formattedValue}`;
                                                }
                                            }
                                        },
                                    },
                                    scales: {
                                        x: {
                                            title: {
                                                display: true,
                                                text: "Employee's Name"
                                            },
                                            ticks: {
                                                font: {
                                                    size: 9, // Control the font size for x-axis labels
                                                },
                                            },
                                        },
                                        y: {
                                            title: {
                                                display: true,
                                                text: 'Sales',
                                            },
                                            ticks: {
                                                callback: function (value) {
                                                    if (value >= 10000000) {
                                                        return (value / 10000000).toFixed(0) + 'C'; // Crores
                                                    } else if (value >= 100000) {
                                                        return (value / 100000).toFixed(0) + 'L'; // Lakhs
                                                    } else if (value >= 1000) {
                                                        return (value / 1000).toFixed(0) + 'K'; // Thousands
                                                    } else {
                                                        return value; // Less than 1000
                                                    }
                                                },

                                            },

                                        },
                                    },
                                }}
                            />
                            {/* <br /> */}
                            {/* <Button type="primary" onClick={showModal}>
                                View All Employee
                            </Button> */}
                            <Modal
                                title="Employee Sales Overview"
                                visible={isModalVisible}
                                onCancel={handleCancel}
                                footer={null}
                            >
                                <br />
                                <div id='EmployeeContainer'>
                                    <Table dataSource={allData} columns={columns} />
                                </div>
                            </Modal>
                        </div>
                    </Col>
                    <Col span={12}>
                        <div className='CardEdit' >
                            <div style={{ display: "flex", width: "100%", justifyContent: "space-between", alignItems: "center" }}>
                                <h6>Top Areas</h6>
                                <Button onClick={() => handleTabChange(4)} style={{width:"100px"}}>View Details</Button>
                            </div>
                            <div>
                                {/* <br /> */}
                                <Bar
                                    data={chartData}
                                    options={{
                                        responsive: true,
                                        plugins: {
                                            legend: {
                                                display: false
                                            },
                                            title: {
                                                display: false,
                                                text: 'Sales Data by Area',
                                            },
                                        },
                                        scales: {
                                            x: {
                                                title: {
                                                    display: true,
                                                    text: "Area",

                                                },
                                                ticks: {
                                                    font: {
                                                        size: 9, // Control the font size for x-axis labels
                                                    },
                                                },
                                            },
                                            y: {
                                                title: {
                                                    display: true,
                                                    text: 'Sales',
                                                },
                                                ticks: {
                                                    callback: function (value) {
                                                        if (value >= 10000000) {
                                                            return (value / 10000000).toFixed(0) + 'C'; // Crores
                                                        } else if (value >= 100000) {
                                                            return (value / 100000).toFixed(0) + 'L'; // Lakhs
                                                        } else if (value >= 1000) {
                                                            return (value / 1000).toFixed(0) + 'K'; // Thousands
                                                        } else {
                                                            return value; // Less than 1000
                                                        }
                                                    },

                                                },
                                            },
                                        },
                                    }}
                                />
                                {/* <br />
                                <br /> */}
                                {/* <Button type="primary" onClick={showMoreModal}>
                                    View Total Areas
                                </Button> */}
                                <Modal
                                    title="All Areas Data"
                                    visible={isMoreModalVisible}
                                    onCancel={handleCancel}
                                    footer={null}
                                >
                                    <br />

                                    <div id='AreaContainer'>
                                        <Table
                                            columns={AreWisecolumns}
                                            dataSource={areaChart}
                                            pagination={true}
                                        />
                                    </div>
                                </Modal>
                            </div>
                        </div>
                    </Col>
                    <Col span={12}>
                        <div className='CardEdit'>
                            <h6>Top Industries</h6>
                            <div style={{ width: "70%", display: "flex", justifyContent: "center", margin: "auto" }}>
                                <Doughnut
                                    data={industryChartData}
                                    options={{
                                        responsive: true,
                                        plugins: {
                                            legend: {
                                                display: true,
                                                position: 'right',
                                            },
                                            title: {
                                                display: false,
                                                text: 'Sales Data by Industry',
                                            },
                                            tooltip: {
                                                callbacks: {
                                                    label: function (context) {
                                                        const label = context.label || '';
                                                        const value = context.raw || 0;
                                                        return `${label}: ${value}`;
                                                    }
                                                }
                                            }
                                        },
                                        cutout: '50%', // Size of the central hole
                                    }}
                                />
                            </div>
                            {/* <Button onClick={setIsModalVisiblePie} type='primary'>View All Industries</Button> */}

                            <Modal
                                title="Industry Data"
                                visible={isModalVisiblePie}
                                onCancel={handleCancel}
                                footer={null}
                            >
                                <div id='IndustryDataContainer'>
                                    <Table
                                        columns={PieChartColums}
                                        dataSource={modalData}
                                        rowKey="brandSegment"
                                    />
                                </div>
                            </Modal>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default BarChartComponent;
